import { Attachment } from '../../models';
import { DataStore } from 'aws-amplify';
import { SubscriptionMessage } from '@aws-amplify/datastore';
import { useQueryClient } from 'react-query';

let subscription: ZenObservable.Subscription | undefined;


export const useAttachmentSubscription = () => {
    const queryClient = useQueryClient();

    const subscribe = async (propertyId: string) => {
        subscription = DataStore.observe(Attachment, (attachment) =>
            attachment.propertyId("eq", propertyId)
        ).subscribe({
            next: (message: SubscriptionMessage<Attachment>) => {
                queryClient.invalidateQueries("attachments");
            },
            error: (error) => console.warn(error)
        });
    };

    const unsubscribe = () => {
        subscription?.unsubscribe();
    };

    return { subscribe, unsubscribe };
};